import * as React from 'react';
import LeafletItemSkeleton from '../LeafletItem/LeafletItemSkeleton';
import * as styles from './LeafletGridGroup.scss';

interface ILeafletGridGroupSkeletonProps {
  size?: 's' | 'm' | 'l',
  gridKey?: string,
  moreLabel?: string,
  columns?: '1' | '2' | '3',
}

class LeafletGridGroupSkeleton extends React.Component<ILeafletGridGroupSkeletonProps, {}> {
  public static defaultProps = {
    columns: 3,
    gridKey: 'default',
    size: 'm',
  };

  public render () {
    const { size, gridKey,columns } = this.props;

    return (
      <div className={`${styles.GroupWrapper} ${styles[ 'GroupColumns' + columns ]}`}>
	      <div className={`${styles.Group}`}>
	        {[1,2,3,4,5,6].map((indx) => (
	          <div className={styles.GroupItem} key={`leaflet-grid-item-${gridKey}-${indx}`}>
	            <div className={styles.GroupItemInner}>
	              <LeafletItemSkeleton
	                size={size}
	              />
	             </div>
	          </div>
	          )
	        )}
	        </div>
        </div>
    );
  }
}

export default LeafletGridGroupSkeleton;
